<template>
    <div class="popup-wrap" @click="closePopup()" v-if="popupVisible">
        <div class="popup-window">
                <h2>Witamy,</h2>
                <p>W związku z przerwą świąteczną Dział Obsługi Konsumenta oraz Dział Serwisu nie pracują w dniach<br>
                    <strong>23 grudnia</strong> do <strong>1 stycznia.</strong></p>
                    <p>Zapraszamy do kontaktu od 2 stycznia w standardowych godzinach pracy wymienionych działów. </p>
            <p>Życzymy Wesołych Świąt oraz szczęśliwego Nowego Roku,<br>
              Zespół Le Grand</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "XmasContact",
        data() {
            return {
                popupVisible: true
            }
        },
        methods: {
            closePopup() {
                this.popupVisible = false;
            }
        }
    }
</script>

<style scoped>
    .popup-wrap {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, .6);
        z-index: 9999;
    }

    .popup-wrap .popup-window {
        margin: auto;
        padding: 2em;
        background-color: white;
        color: black;
        -webkit-box-shadow: 10px 10px 30px rgba(0, 0, 0, .2);
        box-shadow: 10px 10px 30px rgba(0, 0, 0, .2);
        width: 74%;
        height: 47vw;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        position: absolute;
    }
    .popup-wrap .popup-window p,
    .popup-wrap .popup-window h2
    {
        text-align: center;
        color: #666;
    }

    @media screen and (min-width: 1024px) {
        .popup-wrap .popup-window {
            width: 28vw;
            height: 16vw;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Popups/XmasContact.vue